import { TranslationFunction } from 'i18next'
import React, { SFC } from 'react'
import { NavLink, RouteComponentProps } from 'react-router-dom'

import { i18nKeys } from '../app.i18n'
import { links } from '../app.links'
import { ACTIVE_CLASS_NAME, NAVLINK_CLASS_NAME } from '../shared'

type Props = RouteComponentProps<{}> & {
  t: TranslationFunction
}

export const ReportsNav: SFC<Props> = ({ match, t }) => (
  <>
    <div className="sidebar__title">{t(i18nKeys.frontFace.activityBar.reports)}</div>
    <NavLink className={NAVLINK_CLASS_NAME} activeClassName={ACTIVE_CLASS_NAME} to={links.reports.personGoals.home()}>
      {t(i18nKeys.admin.reports.personGoals)}
    </NavLink>
    <NavLink className={NAVLINK_CLASS_NAME} activeClassName={ACTIVE_CLASS_NAME} to={links.reports.perfGoals.home()}>
      {t(i18nKeys.admin.reports.perfGoals)}
    </NavLink>
    <NavLink className={NAVLINK_CLASS_NAME} activeClassName={ACTIVE_CLASS_NAME} to={links.reports.devGoals.home()}>
      {t(i18nKeys.admin.reports.devGoals)}
    </NavLink>
    <NavLink className={NAVLINK_CLASS_NAME} activeClassName={ACTIVE_CLASS_NAME} to={links.reports.idp.home()}>
      {t(i18nKeys.admin.reports.idp)}
    </NavLink>
    <NavLink className={NAVLINK_CLASS_NAME} activeClassName={ACTIVE_CLASS_NAME} to={links.reports.reviews.home()}>
      {t(i18nKeys.admin.reports.reviews)}
    </NavLink>
  </>
)



// WEBPACK FOOTER //
// ./src/app/sidebar-navigation/reports.tsx